/*
Copyright 2025 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const DataCorrelatedIcon = ({
  width = 24,
  height = 24,
  hidden = false,
  title = 'Data Correlated',
} = {}): string | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    height="${height}"
    viewBox="0 0 36 36"
    width="${width}"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="M26 14c0-.4-.021-.8-.06-1.188A9.995 9.995 0 0 0 12.812 25.94c.391.039.787.06 1.188.06a12 12 0 0 0 12-12Z"
    />
    <path
      d="M10 22a12 12 0 0 1 15.482-11.482 12 12 0 1 0-14.964 14.964A11.989 11.989 0 0 1 10 22ZM25.482 10.518a11.907 11.907 0 0 1 .458 2.294A10 10 0 1 1 12.812 25.94a11.907 11.907 0 0 1-2.294-.458 12 12 0 1 0 14.964-14.964Z"
    />
  </svg>`;
};
